import { csv } from '@/shared/extensions/dotenv'

const STORE_ADMIN_PERMISSIONS = csv(process.env.VUE_APP_STORE_ADMIN_PERMISSIONS)
const ORGANIZATION_ADMIN_PERMISSIONS = csv(process.env.VUE_APP_ORGANIZATION_ADMIN_PERMISSIONS)

export { STORE_ADMIN_PERMISSIONS, ORGANIZATION_ADMIN_PERMISSIONS }
